import moment from 'moment-timezone'

const ALL_DAY_END = '00:00:00'

export function resolveEventTimezone (event, timezones) {
  if (!event || event.timezone === null || event.timezone === undefined || event.timezone === '') return null
  const tz = event.timezone
  if (typeof tz === 'number' || /^\d+$/.test(String(tz))) {
    const id = Number(tz)
    const match = Array.isArray(timezones) ? timezones.find(t => t.id === id) : null
    return match ? match.value : null
  }
  return moment.tz.zone(tz) ? tz : null
}

export function isNowAfterEventEnd (event, now, timezones) {
  if (!event || !event.end_date) return false
  const reference = now instanceof Date ? now : new Date(now)
  const tz = resolveEventTimezone(event, timezones)
  const allDayBoundary = event.type === 'action_plan' ? '23:59:59' : ALL_DAY_END
  const allDay = event.end_date.slice(11) === allDayBoundary

  if (allDay) {
    const today = tz
      ? moment(reference).tz(tz).format('YYYY-MM-DD')
      : moment(reference).format('YYYY-MM-DD')
    return event.end_date.slice(0, 10) < today
  }

  const end = tz
    ? moment.tz(event.end_date, 'YYYY-MM-DD HH:mm:ss', tz)
    : moment(event.end_date, 'YYYY-MM-DD HH:mm:ss')
  return moment(reference).isAfter(end)
}

export function isNowWithinEventWindow (event, now, timezones) {
  if (!event || !event.start_date || !event.end_date) return false
  const reference = now instanceof Date ? now : new Date(now)
  const tz = resolveEventTimezone(event, timezones)
  const allDay = event.end_date.slice(11) === ALL_DAY_END

  if (allDay) {
    const today = tz
      ? moment(reference).tz(tz).format('YYYY-MM-DD')
      : moment(reference).format('YYYY-MM-DD')
    return event.end_date.slice(0, 10) === today ||
      (event.start_date.slice(0, 10) <= today && today < event.end_date.slice(0, 10))
  }

  const start = tz
    ? moment.tz(event.start_date, 'YYYY-MM-DD HH:mm:ss', tz)
    : moment(event.start_date, 'YYYY-MM-DD HH:mm:ss')
  const end = tz
    ? moment.tz(event.end_date, 'YYYY-MM-DD HH:mm:ss', tz)
    : moment(event.end_date, 'YYYY-MM-DD HH:mm:ss')
  const ref = moment(reference)
  return ref.isAfter(start) && ref.isBefore(end)
}
